import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51739497&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51739497",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51739497')) {
      api.createRecord('51739497', component.options)
    } else {
      api.reload('51739497', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=51739497&scoped=true", function () {
      api.rerender('51739497', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/activity_center/activity_write_off/components/input_click/index.vue"
export default component.exports